import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IRoomRequest } from 'src/app/model/hotel.model';
import { AppContext } from 'src/app/services/app-context.service';
// import { IRoomRequest } from 'src/app/model/hotel.model';

@Component({
  selector: 'travel-ui-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit {

  passangerTypes = [
    {
      type: "Adult",
      subtitle: "Age 18+",
      minValue: 1,
      maxValue: 8
    },
    {
      type: "Children",
      subtitle: "Age 17 or younger",
      minValue: 0,
      maxValue: 4
    }
  ];


  @Input()
  set presetRoomsPassengers(data: any) {
    if (data.length) {
      this.rooms = data;
    }
  }

  @Input() maxGuestCountPerRoom = 11;
  @Input() mobileView?: boolean;

  rooms: any;
  enableRemoveRoomBtn = false;
  disableAddRoomBtn = false;

  @Output() done: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(public appContext: AppContext) { }

  closeDatePopover() {
    this.close.emit();
  }

  handleChange(e: any, passangerType: any, room: IRoomRequest) {

    if (passangerType.type === 'Adult') {
      room.adults = e.newValue;
    } else {
      room.children = e.newValue;
    }

    if (this.getTotalCounts(room) > this.maxGuestCountPerRoom) {
      setTimeout(() => {
        if (passangerType.type === 'Adult') {
          room.adults = e.previousValue;
        } else {
          room.children = e.previousValue;
        }
      }, 10);
      return;
    }

    if (passangerType.type === 'Children') {
      if (!room.childAges) {
        room.childAges = [];
      }
      if (e.previousValue < e.newValue) {
        room.childAges.push(1);
      } else {
        room.childAges.pop();
      }
    }
  }

  onChange(event: any, index: any, room: any) {

    room.childAges[index] = event.target.value;
  }

  getTotalCounts(room: any) {

    return room.adults + (room.children || 0);
  }

  addRoom() {

    this.rooms.push({
      adults: 2,
      children: 0,
      childAges: []
    });

    this.enableRemoveRoomBtn = this.rooms.length > 1 ? true : false;
    this.disableAddRoomBtn = this.rooms.length > 7 ? true: false;
  }

  removeRoom() {
    if (this.rooms.length > 1) {
      this.rooms.pop();
    }
    this.enableRemoveRoomBtn = this.rooms.length > 1 ? true : false;
    this.disableAddRoomBtn = this.rooms.length > 7 ? true: false;
  }

  doneChanges() {
    this.done.emit(this.rooms);
  }

  childrenExist(room: any) {
    const childType = room.passangerTypes.find((item: { type: string; }) => {
      return item.type === 'Children';
    });
    return childType && childType.count ? true : false;
  }

  getCount(type: any, room: any) {
    return type === 'Adult' ? room.adults : (room.children || 0);
  }

  ngOnInit() {
    this.enableRemoveRoomBtn = this.rooms.length > 1;
  }
}
